import { useQuery } from "@tanstack/react-query";
import { apiClient, useAuthentication } from "@repo/core";
import type { ActiveSubscription } from "@repo/core";

export type { ActiveSubscription };

/** The only permission the subscription endpoint is queried with today. */
export const FACTOR_INVESTING_BASIC_PERMISSION = "Factor_investing_basic";

/**
 * Load the current user's active subscription for a product permission.
 *
 * Hits `{ANP_HOST}/api/subscription/active/?permission={permission}&page_size=1`
 * — same host and JWT auth as the user-details endpoint (`apiClient`), not the
 * AWS Amplify API. Resolves to the single subscription record, or `null` when
 * the user has none for that permission.
 */
export function useActiveSubscription(
    permission: string = FACTOR_INVESTING_BASIC_PERMISSION
) {
    const { isAuthenticated } = useAuthentication();

    return useQuery<ActiveSubscription | null, Error>({
        queryKey: ["active-subscription", permission],
        enabled: isAuthenticated,
        queryFn: async () => {
            const { data } = await apiClient.getActiveSubscription(permission);
            return data.results[0] ?? null;
        },
    });
}
